module.exports = __webpack_public_path__ + "static/media/TN-Men-Shoes-v2.0-OA.4bffd1a3.svg";